import React, { useEffect, useState } from "react";
import httpApiCall from "../../../service/api.service";
import {
  getCurrentTimezone,
  getStorageValue,
} from "../../../service/shared.service";
import moment from "moment-timezone";
import toastr from "../../elements/toast";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
// import moment from 'moment';
import { Field, Form, Formik } from "formik";
import "./schedule-training.scss";
import "../../../style/style.scss";
import { Calendar, DateRangePicker } from "react-date-range";
import { backblack } from "../../../assets/assets";

const ScheduleTraining = () => {
  const today = new Date(); // Get the current date
  const lastDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + 35
  );
  const [selected_training_data, set_selected_training_data] = useState({
    selected_time_lots: [],
    selected_index: -1,
    selected_date: "",
    schedule_time_slot: "",
    selected_full_date_time_string: "",
  });
  const [locationData, setLocation] = useState({
    locations: [],
    selected_location: -1,
    locationFilter: [],
  });
  const [timezoneData, setTimezoneData] = useState({
    timezone: "",
    training_timezones: [],
    current_timezone: "",
    timezone_short_name: "",
    scheduled_timezone: "",
  });
  const [training_timezones, set_training_timezones] = useState([]);
  const [dateData, setDateData] = useState({
    today: new Date(),
    selectedDate: "",
    lastDate: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() + 35
    ),
  });
  const [trainingData, setTrainingData] = useState({
    training_types: [],
    training_type: "",
    selected_training: {
      duration: 0,
      description: "",
      name: "",
    },
    training_data: [],
    scheduled_training_date: "",
    scheduled_training_time: "",
  });
  // const [training_data, set_training_data] = useState([]);

  const [allVariables, setAllVariables] = useState({
    old_event_id: 0,
    isWeekend: false,
    offsetFromCurrentWeek: 0,
    tcr_height: false,
  });
  const [slotsLoader, set_slotsLoader] = useState(false);
  const [showConfirm, set_showConfirm] = useState(false);
  const [showMode, set_showMode] = useState(false);
  const [loader, set_loader] = useState(false);
  const [openboxes, set_openboxes] = useState(false);
  const [queryParameters] = useSearchParams();
  const toastrService = new toastr(true);
  const navigate = useNavigate();
  const params = useParams();
  let intialValue = {};
  useEffect(() => {
    const fetchTrainingTimezones = async () => {
      let data = {
        access_token: getStorageValue("partnerToken"),
      };
      await httpApiCall({
        body: data,
        api: "fetch_timezones",
        type: "post",
      }).then(
        (data: any) => {
          if (data && data.is_error == 0) {
            const training_timezones: any = [];
            var timezoneDataAll = data.data;
            for (var i = 0; i < timezoneDataAll.length; i++) {
              var tzOffset =
                parseInt(
                  timezoneDataAll[i].val.substring(
                    0,
                    timezoneDataAll[i].val.length - 2
                  )
                ) *
                  60 +
                parseInt(
                  timezoneDataAll[i].val.substring(
                    timezoneDataAll[i].val.length - 2
                  )
                );
              var timezoneHours = parseInt(parseInt(tzOffset + "") / 60 + "");
              timezoneHours =
                timezoneHours < 0 ? -1 * timezoneHours : timezoneHours;
              var timezoneMinutes = tzOffset % 60;
              timezoneMinutes =
                timezoneMinutes < 0 ? -1 * timezoneMinutes : timezoneMinutes;
              var timezoneString =
                (tzOffset < 0 ? "-" : "+") +
                (timezoneHours < 10 ? "0" : "") +
                timezoneHours +
                ":" +
                (timezoneMinutes < 10 ? "0" : "") +
                timezoneMinutes;
              training_timezones.push({
                code: timezoneDataAll[i].offset,
                val: timezoneDataAll[i].val,
                timezoneName: timezoneDataAll[i].name,
                tzOffset: tzOffset,
                timezoneString: timezoneString,
              });
            }
            var selected_zone_name = training_timezones[0].timezoneName;
            var selectedUtcOffset = training_timezones[0].tzOffset;
            var currentUtcOffset = moment().utcOffset();
            var timezoneWithCurrentUtcOffset = training_timezones.find(
              (timezone: any) => timezone.tzOffset === currentUtcOffset
            );
            if (timezoneWithCurrentUtcOffset) {
              selected_zone_name = timezoneWithCurrentUtcOffset.timezoneName;
              selectedUtcOffset = timezoneWithCurrentUtcOffset.tzOffset;
            }
            const current_timezone =
              selected_zone_name + "****" + selectedUtcOffset;
            timezoneData.training_timezones = training_timezones;
            intialValue = {
              timezone_id:
                timezoneData.training_timezones[0]["timezoneName"] +
                "****" +
                timezoneData.training_timezones[0]["tzOffset"],
              partner_training_id: trainingData.training_type,
            };
            setTimezoneData(timezoneData);
            set_training_timezones(training_timezones);
            timezoneData.current_timezone = current_timezone;
            // setTimezoneData(Object.assign(
            //    {},
            //    timezoneData,
            //    {
            //       training_timezones: training_timezones, current_timezone: current_timezone
            //    }
            // ))
            getBookableTimeSlots();
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    };
    const fetchTrainingTypes = async () => {
      let data = {
        access_token: getStorageValue("partnerToken"),
      };
      await httpApiCall({
        body: data,
        api: "fetch_training_types",
        type: "post",
      }).then(
        (data: any) => {
          if (data && data.is_error == 0) {
            const training_types = data.data.filter(
              (type: any) => type.type_id == 8
            );
            const selected_training = training_types[0];
            const training_type = selected_training["type_id"];
            trainingData.training_types = training_types;
            trainingData.selected_training = selected_training;
            trainingData.training_type = training_type;
            // setTrainingData(Object.assign(
            //    {},
            //    trainingData,
            //    {training_types: training_types, selected_training: selected_training, training_type: training_type}
            // ))
            fetchTrainingTimezones();
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    };
    const selectedDate = moment(dateData.today).format("yyyy-MM-DD");
    // setDateData({
    //    ...dateData,
    //    selectedDate: selectedDate
    // })
    dateData.selectedDate = selectedDate;
    var dayOfWeek = dateData.today.getDay();
    allVariables.isWeekend = dayOfWeek === 6 || dayOfWeek === 0;

    // setAllVariables(Object.assign(
    //    {},
    //    allVariables,
    //    {isWeekend: isWeekend}
    // ))
    if (allVariables.isWeekend) {
      toastrService.showError(
        "Please choose another date.Training can't be scheduled on weekend"
      );
    } else {
      fetchTrainingTypes();
    }

    timezoneData.timezone = getCurrentTimezone();
    // setTimezoneData(Object.assign(
    //    {},
    //    timezoneData,
    //    {timezone: timezone}
    // ))
    // timezoneData.current_timezone
    if (params && params["event_id"]) {
      allVariables.old_event_id = Number(params["event_id"]);
      // console.log(allVariables.old_event_id);
      // setAllVariables(Object.assign(
      //    {},
      //    allVariables,
      //    {old_event_id: queryParameters.get("event_id")}
      // ))
    }
  }, []);

  const showConf = (slot: any) => {
    set_selected_training_data((prev:any) => ({
      ...prev,
      selected_full_date_time_string: slot.fullDateTimeString,
      schedule_time_slot: slot.time_slot
    }));
  
    set_showConfirm(true);
  };

  const onDateChange = async (event: any) => {
    set_openboxes(false);
    // setAllVariables(Object.assign(
    //    {},
    //    allVariables,
    //    {openboxes: false}
    // ))
    if (event !== dateData.today) {
      let dateVal = event;
      dateData.today = event;
      setTimeout(() => {
        // const type = timezoneData.training_timezones.filter(
        //   (item) => item["val"] == timezoneData.timezone
        // );
        // if (type && type.length > 0) {
          const selectedDate = moment(dateVal)
            // .tz(type && type[0] && type[0]["timezoneName"])
            .format("yyyy-MM-DD");
          dateData.selectedDate = selectedDate;
        // }
        // setDateData(Object.assign(
        //    {},
        //    dateData,
        //    {selectedDate: selectedDate}
        // ))
        // selectedDate = moment(dateVal, 'yyyy-MM-dd', timezoneData.timezone);
        var dayOfWeek = dateVal.getDay();
        allVariables.isWeekend = dayOfWeek === 6 || dayOfWeek === 0;
        // setAllVariables(Object.assign(
        //    {},
        //    allVariables,
        //    { isWeekend: isWeekend }
        // ))
        if (allVariables.isWeekend) {
          trainingData.training_data = [];
          // set_training_data([]);
          // setTrainingData(Object.assign(
          //    {},
          //    trainingData,
          //    { training_data: [] }
          // ))
          toastrService.showError(
            "Please choose another date.Training can't be scheduled on weekend"
          );
        } else {
          if (event) {
            // console.log(moment(event).format());
            getBookableTimeSlots({}, moment(event).format())
          }
        }
      }, 500);
    }
  };

  let initialValues = {};

  const changeTimeZone = (value: any) => {
    // console.log(value);
    timezoneData.current_timezone = value;
    getTimeSlotsFunctionality();
  };

  const getTimeSlotsFunctionality = async (date: any = '') => {
    let trainingAllData: any = [];
    set_showConfirm(false);
    // slotsLoader = true;
    set_slotsLoader(true);
    // console.log(timezoneData.current_timezone);
    var selectedUtcOffset = parseInt(
      timezoneData.current_timezone.split("****")[1]
    );
    var timezoneHours = parseInt(String(selectedUtcOffset / 60));
    timezoneHours = timezoneHours < 0 ? -1 * timezoneHours : timezoneHours;
    var timezoneMinutes = selectedUtcOffset % 60;
    timezoneMinutes =
      timezoneMinutes < 0 ? -1 * timezoneMinutes : timezoneMinutes;
    var timezoneString =
      (selectedUtcOffset < 0 ? "-" : "+") +
      (timezoneHours < 10 ? "0" : "") +
      timezoneHours +
      ":" +
      (timezoneMinutes < 10 ? "0" : "") +
      timezoneMinutes;

    var startWeekDay = moment().utcOffset(selectedUtcOffset).day();
    var begin = moment()
      .utcOffset(selectedUtcOffset)
      .startOf("isoWeek")
      .isoWeekday(startWeekDay)
      .add(allVariables.offsetFromCurrentWeek, "weeks");
    var reqData;
    for (let i = 0; i < 36; i++) {
      if (begin.day() !== 6 && begin.day() !== 0) {
        var dateString = begin.format("MMM DD");
        var dateSlotsObj = {
          dayName: begin.format("dddd"),
          date: dateString,
          shortDate: begin.format("YYYY-MM-DD"),
          fullDateString: begin.format(),
          all_slots: [],
        };

        var all_slot: any = [];
        for (var j = 0; j < 24 * 4; j++) {
          var timeHours = parseInt(String(j / 4));
          var timeMinutes = (j % 4) * 15;
          var timeString =
            (timeHours >= 10 ? "" : "0") +
            timeHours +
            ":" +
            ((timeMinutes >= 10 ? "" : "0") + timeMinutes);
          if (timeMinutes === 0) {
            all_slot.push({
              time: timeString,
              disable: 1,
              time_slots: [],
              timeAmPm: moment(
                moment().format("YYYY-MM-DD") + "T" + timeString
              ).format("hh:mm A"),
            });
          }
          all_slot[all_slot.length - 1].time_slots.push({
            time_slot: timeString,
            timeAmPm: moment(
              moment().format("YYYY-MM-DD") + "T" + timeString
            ).format("hh:mm A"),
            fullDateTimeString: moment(
              begin.format("YYYY-MM-DD") +
                "T" +
                timeString +
                ":00" +
                timezoneString
            ).format(),
            disable: 1,
          });
          if (j == 24 * 4 - 1) {
            dateSlotsObj["all_slots"] = all_slot;
            trainingAllData.push(dateSlotsObj);
            trainingAllData = trainingAllData.filter(
              (ele: any) => ele.shortDate === dateData.selectedDate
            );
            set_showMode(false);
          }
        }
      }
      begin.add(1, "days");
      if (i == 35) {
        var startDateString =
          trainingAllData &&
          trainingAllData.length &&
          trainingAllData[0]?.fullDateString;
        var endDateTimestamp =
          parseInt(
            moment(trainingAllData[trainingAllData.length - 1]?.fullDateString)
              .utc()
              .format("X")
          ) +
          24 * 35 * 60 * 60;
        var endDateString = moment(endDateTimestamp * 1000)
          .utcOffset(selectedUtcOffset)
          .format();

        var timezoneParts = timezoneData.current_timezone.split("****");
        var tzOffset = parseInt(timezoneParts[1]);
        var timezoneWithCurrentUtcOffset: any =
          timezoneData.training_timezones.find(
            (timezone: any) => timezone.tzOffset === tzOffset
          );
        trainingData.training_data = trainingAllData;
        // console.log(trainingData.training_data);
        set_showMode(false);
        // set_training_data(trainingAllData);
        reqData = {
          reqData: {
            access_token: getStorageValue("partnerToken"),
            start_date: startDateString ,
            end_date: endDateString,
            training_type: trainingData.training_type,
            timezone_short_name:
              timezoneWithCurrentUtcOffset && timezoneWithCurrentUtcOffset.code,
          },
          extra_data: {
            timezone_short_name:
              timezoneWithCurrentUtcOffset && timezoneWithCurrentUtcOffset.code,
            training_data: trainingAllData,
          },
        };
        callTimeSlots(reqData);
      }
    }
  };

  const callTimeSlots = async (data: any) => {
    getBookableTimeSlots(data);
  };

  const getBookableTimeSlots = async (reqData: any = {}, date: any = '') => {
    if (
      !reqData ||
      (reqData && !reqData.reqData) ||
      (reqData && reqData.reqData && !reqData.reqData.access_token)
    ) {
      return getTimeSlotsFunctionality(date);
    }

    await httpApiCall({
      body: reqData.reqData,
      api: "get_bookable_time_slots_for_partner",
      type: "post",
    }).then(
      (data: any) => {
        reqData = reqData.extra_data;
        // allVariables.slotsLoader = false;
        set_slotsLoader(false);
        if (data && data.is_error == 0) {
          var allAvailableSlots = data.availableSlots;
          if (allAvailableSlots) {
            var trainingDuration = parseInt(data.trainingDuration);
            for (var i = 0; i < reqData.training_data.length; i++) {
              var shortDate = reqData.training_data[i].shortDate;
              var dateAvailableSlots = allAvailableSlots[shortDate];
              if (dateAvailableSlots) {
                var availableStartTimes = [];
                for (var j = 0; j < dateAvailableSlots.length; j++) {
                  for (var k = 0; k < dateAvailableSlots[j].length; k++) {
                    var startMinutes = dateAvailableSlots[j][k].startMinutes;
                    var endMinutes = dateAvailableSlots[j][k].endMinutes;

                    if (endMinutes - startMinutes >= trainingDuration) {
                      for (
                        var l = startMinutes;
                        l <= endMinutes - trainingDuration;
                        l += 15
                      ) {
                        var timeSlotHours = parseInt(String(l / 60));
                        var timeSlotMinutes = l % 60;
                        var timeSlotString =
                          (timeSlotHours < 10 ? "0" : "") +
                          timeSlotHours +
                          ":" +
                          (timeSlotMinutes < 10 ? "0" : "") +
                          timeSlotMinutes;
                        if (
                          availableStartTimes.indexOf(timeSlotString) === -1
                        ) {
                          availableStartTimes.push(timeSlotString);
                        }
                      }
                    }
                  }
                }
                if (availableStartTimes.length > 0) {
                  var date_parent_time_slots =
                    reqData.training_data[i].all_slots;
                  for (var j = 0; j < date_parent_time_slots.length; j++) {
                    var childTimeSlots = date_parent_time_slots[j].time_slots;
                    for (var k = 0; k < childTimeSlots.length; k++) {
                      if (
                        availableStartTimes.indexOf(
                          childTimeSlots[k].time_slot
                        ) !== -1
                      ) {
                        date_parent_time_slots[j].disable = 0;
                        childTimeSlots[k].disable = 0;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  };

  const trainingChanged = async () => {
    trainingData.selected_training = trainingData.training_types.filter(
      (training: any) => training.type_id == trainingData.training_type
    )[0];
  };
  const getEnabledSlotsFromArray = (slotsArray: any) => {
    return slotsArray.filter((slot: any) => slot.disable == 0);
  };
  const confirmBooking = async () => {
    var timezoneParts = timezoneData.current_timezone.split("****");
    var timezoneName = timezoneParts[0];
    var tzOffset = parseInt(timezoneParts[1]);
    var timezoneWithCurrentUtcOffset: any =
      timezoneData.training_timezones.find(
        (timezone: any) => timezone.tzOffset === tzOffset
      );

    var selected_full_date_time_string = moment(
      selected_training_data.selected_full_date_time_string
    ).utcOffset(tzOffset).format();
    var reqData = {
      access_token: getStorageValue("partnerToken"),
      training_type: trainingData.training_type,
      start_date_time: selected_full_date_time_string,
      timezone_full_name: timezoneName,
      timezone_short_name:
        timezoneWithCurrentUtcOffset && timezoneWithCurrentUtcOffset.code,
      old_event_id: 0,
    };
    if (allVariables.old_event_id) {
      reqData.old_event_id = allVariables.old_event_id;
    }
    set_loader(true);
    await httpApiCall({
      body: reqData,
      api: "book_partner_training",
      type: "post",
    }).then(
      (data: any) => {
        set_loader(false);
        if (data && data.is_error == 0) {
          trainingData.scheduled_training_time = moment(
            selected_training_data.selected_full_date_time_string
          )
            .utcOffset(tzOffset)
            .format("hh:mm A");
          trainingData.scheduled_training_date = moment(
            selected_training_data.selected_full_date_time_string
          )
            .utcOffset(tzOffset)
            .format("DD MMM, YYYY");
          timezoneData.scheduled_timezone =
            timezoneName +
            " (GMT" +
            timezoneWithCurrentUtcOffset.timezoneString +
            ")";
          toastrService.showSuccess(data.override_text);
          setTimeout(() => {
            navigate("/app/training-list/");
          });
        } else {
          toastrService.showError(data.override_text || data.err);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  };
  // const cancelBooking = async () => {
  //    set_selected_training_data({
  //       selected_time_lots: [],
  //       selected_index: -1,
  //       selected_date: "",
  //       schedule_time_slot: "",
  //       selected_full_date_time_string: ""
  //    });
  // }
  const openTooltip = (data: any, time: any, index: any) => {
    set_showMode(false);
    set_openboxes(!openboxes);
    // allVariables.openboxes = !allVariables.openboxes;
    set_showConfirm(false);
    let selected_training_data_copy = selected_training_data;
    selected_training_data_copy.selected_time_lots = time.time_slots;
    selected_training_data_copy.selected_date = data.date;
    selected_training_data_copy.selected_index = index;
    set_selected_training_data(selected_training_data_copy);
  };

  const handleSubmit = async () => {};

  const handleSelect = (date: any) => {
    // console.log(date); // native Date object
  };
  const goBack = () => {
    navigate("/app/training-list");
  };
  const disableWeekends = (date:any) => {
   return date.getDay() === 0 || date.getDay() === 6; // 0 is Sunday, 6 is Saturday
};

// Create an array of disabled dates using disableWeekends function

  return (
    <>
      <div className="back training">
        <button className="mb-0 border-0 bg-transparent" onClick={goBack}>
          {" "}
          <img src={backblack} alt="" />
          Back
        </button>
      </div>
      <div className="row mx-0 schedule-training">
        <div className="row m-0">
          <div className="col-12 py-3">
            <Formik onSubmit={handleSubmit} initialValues={{ intialValue }}>
              <Form>
                <div className="training-wrapper mx-auto">
                  <div className="row">
                    <h2 className="mb-4">Schedule Training</h2>
                    <div className="col-12 col-xl-4 leftPanel">
                      <h5 className="choose_date_txt mb-4 ml-3 mt-0">
                        Training
                      </h5>
                      <div className="form-group mb-4">
                        <div className="wrap m-h-56 h-100 h-56 d-block">
                          <div className="select w-100 h-100 h-56 d-flex justify-content-between align-items-center">
                            <div className="w-100 ">
                              <div className="form-group mb-3 App text-left ">
                                <label className="labels_input">Timezone</label>
                                <div className="arrowSelect">
                                  <Field
                                    className="form-control"
                                    as="select"
                                    name="timezone_id"
                                    onChange={(event: any) =>
                                      changeTimeZone(event.target.value)
                                    }
                                  >
                                    {training_timezones.map(
                                      (e: any, i: any) => (
                                        <option
                                          key={i}
                                          value={
                                            e.timezoneName + "****" + e.tzOffset
                                          }
                                        >
                                          {e.timezoneName}(GMT{e.timezoneString}
                                          )
                                        </option>
                                      )
                                    )}
                                  </Field>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group mb-4">
                        <div className="wrap d-block">
                          <div className="select w-100 h-100 d-flex justify-content-between align-items-center">
                            <div className="w-100 h-100">
                              <div className="form-group mb-3">
                                <label htmlFor="" className="labels_input">
                                  Type of Training
                                </label>
                                <div className="arrowSelect">
                                  <Field
                                    className="form-control"
                                    as="select"
                                    name="partner_training_id"
                                    onChange={(event: any) => trainingChanged()}
                                  >
                                    {trainingData.training_types.map(
                                      (e: any, i: any) => (
                                        <option key={i} value={e.type_id}>
                                          {e.name}
                                        </option>
                                      )
                                    )}
                                  </Field>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {trainingData.selected_training && (
                        <div className="form-group m-0">
                          <div className="custom-form flex-grow-1 mr-md-3 ">
                            <input
                              className="input_field px-3 pt-3"
                              style={{
                                border: "1px solid #C3C8CD",
                                borderRadius: "8px",
                              }}
                              value="15 minutes"
                              readOnly
                            />
                            <label htmlFor="text" className="label-name">
                              <span className="content-name f-c-p-3">
                                Duration
                              </span>
                            </label>
                          </div>
                        </div>
                      )}

                      {trainingData.selected_training && (
                        <div className="form-group mt-3">
                          <div
                            style={{
                              fontWeight: "400",
                              fontSize: "12px",
                              lineHeight: "20px",
                              color: "#6B7376",
                            }}
                          >
                            {trainingData.selected_training["description"]}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="col-12 col-xl-8 rightPanel">
                      <div className="row">
                        <>
                          <div className="col-md-6 col-12">
                            <h5 className="choose_date_txt mb-4 ml-3 mt-0">
                              Select Date & Time
                            </h5>
                            <Calendar
                              date={dateData && dateData.today}
                              onChange={onDateChange}
                              minDate={today}
                              showMonthAndYearPickers={false}
                              maxDate={lastDate}
                              disabledDay={disableWeekends}
                            />
                          </div>

                          {trainingData.training_data.map((data: any, i) => (
                            <div className="col-md-6 col-12" key={i}>
                              <div className="row flex-column">
                                <div className="slot-header date_txt d-block text-align-center">
                                  <div className="ml-3">
                                      {moment(dateData.today).format('dddd, MMMM Do ')}
                                  </div>
                                  {(!getEnabledSlotsFromArray(data.all_slots) ||
                                    (getEnabledSlotsFromArray(data.all_slots) &&
                                      !getEnabledSlotsFromArray(data.all_slots)
                                        .length &&
                                      !slotsLoader)) && (
                                    <span
                                      className="mt-4 d-inline-block"
                                      style={{ fontSize: "20px" }}
                                    >
                                      No Slots Available
                                    </span>
                                  )}

                                  {slotsLoader && (
                                    <div className="simmer">
                                      <div className="loading-shimmer"></div>
                                      <div className="loading-shimmer"></div>
                                      <div className="loading-shimmer"></div>
                                      <div className="loading-shimmer"></div>
                                      <div className="loading-shimmer"></div>
                                      <div className="loading-shimmer"></div>
                                      <div className="loading-shimmer"></div>
                                      <div className="loading-shimmer"></div>
                                      <div className="loading-shimmer"></div>
                                      <div className="loading-shimmer"></div>
                                      <div className="loading-shimmer"></div>
                                    </div>
                                  )}
                                </div>

                                {!slotsLoader && (
                                  <div className="scroller">
                                    {data.all_slots.map(
                                      (time: any, index: any) => (
                                        <div className="col-12" key={index}>
                                          {!time.disable && (
                                            <div>
                                              <button
                                                type="button"
                                                className={`time-slot-btn ${
                                                  time.disable == 1
                                                    ? " disable_time "
                                                    : ""
                                                } ${
                                                  index ==
                                                    selected_training_data.selected_index &&
                                                  selected_training_data.selected_date ==
                                                    data.date
                                                    ? "time_btn_active"
                                                    : ""
                                                }`}
                                                onClick={() =>
                                                  openTooltip(data, time, index)
                                                }
                                              >
                                                <span>
                                                  <span className="notranslate">
                                                    {time.timeAmPm}
                                                  </span>
                                                </span>
                                              </button>
                                              {selected_training_data.selected_index ==
                                                index && (
                                                <div className="row slot-cols">
                                                  <>
                                                    {openboxes &&
                                                      selected_training_data.selected_time_lots.map(
                                                        (
                                                          timeslots: any,
                                                          index
                                                        ) => (
                                                          <div
                                                            className="col-6"
                                                            key={index}
                                                          >
                                                            <button
                                                              onClick={() => showConf(timeslots)}
                                                              className={`slot-btn ${ timeslots.disable == 1? " disable_time ": ""}
                                                              ${selected_training_data.schedule_time_slot == timeslots.time_slot && 
                                                              selected_training_data.selected_full_date_time_string == timeslots.fullDateTimeString ? "actv" : ""}`}
                                                              disabled={timeslots.disable ==1}
                                                            >
                                                              <span>
                                                                <span className="notranslate">
                                                                  {timeslots.timeAmPm}
                                                                </span>
                                                              </span>
                                                            </button>
                                                          </div>
                                                        )
                                                      )}
                                                    {selected_training_data.selected_full_date_time_string &&
                                                      selected_training_data.schedule_time_slot &&
                                                      showConfirm && (
                                                        <div
                                                          className="col-md-12 col-lg-12 col-sm-12 col-xs-12"
                                                          style={{
                                                            textAlign: "center",
                                                          }}
                                                        >
                                                          <button
                                                            type="button"
                                                            className="slot-active mt-2"
                                                            onClick={() =>
                                                              confirmBooking()
                                                            }
                                                          >
                                                            Confirm
                                                            {loader && (
                                                              <div
                                                                className="ms-2 spinner-border spinner-border-sm"
                                                                role="status"
                                                              >
                                                                <span className="sr-only"></span>
                                                              </div>
                                                            )}
                                                          </button>
                                                          <div
                                                            className="mt-2"
                                                            style={{
                                                              textAlign:
                                                                "justify",
                                                              fontSize: "11px",
                                                              color: "grey",
                                                              marginTop: "15px",
                                                            }}
                                                          >
                                                            <p
                                                              style={{
                                                                overflow:
                                                                  "hidden",
                                                                marginBottom:
                                                                  "0px",
                                                              }}
                                                            >
                                                              By submitting your
                                                              information, you
                                                              agree to our
                                                              Privacy Policy. By
                                                              providing my
                                                              contact
                                                              information I am
                                                              giving
                                                              <span className="notranslate">
                                                                Credee
                                                              </span>
                                                              , LLC (
                                                              <a
                                                                href="https://www.credee.com/"
                                                                target="_blank"
                                                              >
                                                                credee.com
                                                              </a>
                                                              ) permission to
                                                              contact me about
                                                              this and future
                                                              offers using the
                                                              information
                                                              provided. {!allVariables.tcr_height && (<>  I am
                                                              providing{" "}
                                                              <span className="notranslate">
                                                                Credee
                                                              </span>
                                                              , LLC and third
                                                              parties consent to
                                                              contact me through
                                                              emails, calls, and
                                                              text messages to
                                                              my wireless
                                                              telephone numbers.
                                                              I understand
                                                              contact may also
                                                              include but is not
                                                              limited to using
                                                              an automated
                                                              dialing device and
                                                              prerecorded
                                                              messages.
                                                              </>
                                                              )}
                                                            </p>
                                                            {allVariables.tcr_height && (
                                                              <p
                                                                style={{
                                                                  color:
                                                                    "black",
                                                                  fontSize:
                                                                    "14px",
                                                                  textAlign:
                                                                    "right",
                                                                  cursor:
                                                                    "pointer",
                                                                  fontWeight:
                                                                    "bold",
                                                                  marginBottom:
                                                                    "0",
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                onClick={(prevState :any ) => setAllVariables({ ...prevState, tcr_height: false})}
                                                              >
                                                                Show More
                                                              </p>
                                                            )}
                                                            {!allVariables.tcr_height && (
                                                              <p
                                                                style={{
                                                                  color:
                                                                    "black",
                                                                  fontSize:
                                                                    "14px",
                                                                  textAlign:
                                                                    "right",
                                                                  cursor:
                                                                    "pointer",
                                                                  fontWeight:
                                                                    "bold",
                                                                  marginBottom:
                                                                    "0",
                                                                  marginTop:
                                                                    "6px",
                                                                }}
                                                                onClick={(prevState :any ) => setAllVariables({ ...prevState, tcr_height: true})}
                                                                  
                                                                
                                                              >
                                                                Show Less
                                                              </p>
                                                            )}
                                                          </div>
                                                        </div>
                                                      )}
                                                  </>
                                                </div>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      )
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        </>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScheduleTraining;
